import { render, staticRenderFns } from "./ProductVariantItems.vue?vue&type=template&id=83503faa&"
import script from "./ProductVariantItems.vue?vue&type=script&lang=ts&"
export * from "./ProductVariantItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports